export default {"src":"/_next/static/media/or-divider.314dc986.svg","height":28,"width":70,"blurWidth":0,"blurHeight":0};